export default "__VITE_PUBLIC_ASSET__34fff938__"